import React from 'react'
import { MenuItem } from '../..'
import './multilevel-child.css'

interface MultiLevelChildProps {
  data: any
}

export const MultiLevelChild: React.FC<MultiLevelChildProps> = ({ data }) => {
  return (
    <div
      className="multilevel-child-container"
      data-testid="multilevel-child-container"
    >
      {data?.map((child: any, index: number) => {
        // Use a combination of url and title as key, fallback to index if neither exists
        const key = child.url || child.title || `multilevel-child-${index}`

        if (!child.url) {
          return (
            <div
              key={key}
              style={{ marginLeft: '8px' }}
              className="multilevel-child"
            >
              <MenuItem item={child} />
            </div>
          )
        }
        return (
          <a
            key={key}
            href={child.url}
            id={child.url}
            style={{ marginLeft: '8px' }}
            className={
              window.location.pathname === child.url
                ? 'multilevel-child-open multilevel-child'
                : 'multilevel-child'
            }
          >
            <MenuItem item={child} />
          </a>
        )
      })}
    </div>
  )
}
